import cn from 'classnames';
import { groupFieldMap } from '../AdminDeviceGroupsListRow';
import { StyledAdminDeviceGroupsSumRow } from './styles';

export interface IDeviceGroupsListRowProps {
  children?: React.ReactNode;
  sums: {
    normalHashrate: number;
    yesterdayHashrate: number;
    payment: number;
  };
}

const sumFields: (keyof IDeviceGroupsListRowProps['sums'])[] = [
  'normalHashrate',
  'yesterdayHashrate',
  'payment',
];

export const AdminDeviceGroupsSumRow = ({ sums }: IDeviceGroupsListRowProps) => {
  return (
    <StyledAdminDeviceGroupsSumRow>
      {Object.entries(groupFieldMap).map(([title]) => {
        const isSumField = sumFields.includes(title as keyof typeof sums);

        return (
          <div
            key={title}
            className={cn('admin-list-cell-container', title.toLowerCase(), {
              'sum-cell': isSumField,
            })}
          >
            <div className="admin-list-cell-text">
              {isSumField ? sums[title as keyof typeof sums].toLocaleString() : ''}
            </div>
          </div>
        );
      })}
    </StyledAdminDeviceGroupsSumRow>
  );
};
